import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface PainPoint {
  icon: LucideIcon;
  problem: string;
  solution: string;
}

interface PainPointsGridProps {
  title: string;
  subtitle: string;
  points: PainPoint[];
}

export const PainPointsGrid: React.FC<PainPointsGridProps> = ({ title, subtitle, points }) => {
  return (
    <section className="py-24 bg-muted/30 border-y border-border">
      <div className="container px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-foreground">{title}</h2>
          <p className="text-xl text-muted-foreground">{subtitle}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {points.map((pt, i) => (
            <Card key={i} className="bg-card border-border hover:border-primary/50 transition-colors group">
              <CardHeader>
                <div className="w-12 h-12 rounded-xl bg-primary/10 text-primary flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <pt.icon size={24} />
                </div>
                <CardTitle className="text-lg text-red-500/80 font-medium mb-1 line-through decoration-red-500/50 decoration-2">
                    {pt.problem}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-xl font-bold text-foreground">
                  {pt.solution}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
